module.exports = __webpack_public_path__ + "img/help.c4ffe5eb.png";